export enum AnnexedPurchasedOrderStatuses {
  OPEN = 'open',
  RECEIVED = 'received',
  SENT = 'sent',
  CLOSED = 'closed'
}
